import React, { createContext, useContext, useState } from 'react';
import tokens from '@/core/tokens.json';

const defaultUnsavedConfirmationOption = {
  label: tokens['UNSAVED_CONFIRMATION'],
  yesLabel: 'Yes - leave without saving',
  cancelLabel: 'No - go back',
};

export interface ContextUnsavedConfirmationOptionsType {
  label: string;
  yesLabel: string;
  cancelLabel: string;
}
export interface UnsavedConfirmationContextType {
  isUnsavedConfirmationActive: boolean;
  setIsUnsavedConfirmationActive: React.Dispatch<React.SetStateAction<boolean>>;
  contextUnsavedConfirmationOptions: ContextUnsavedConfirmationOptionsType;
  setContextUnsavedConfirmationOptions: React.Dispatch<
    React.SetStateAction<ContextUnsavedConfirmationOptionsType>
  >;
}

const UnsavedConfirmationContext = createContext<UnsavedConfirmationContextType | undefined>(
  undefined,
);

function UnsavedConfirmationProvider({ children }: { children: React.ReactNode }) {
  const [isUnsavedConfirmationActive, setIsUnsavedConfirmationActive] = useState(false);
  const [contextUnsavedConfirmationOptions, setContextUnsavedConfirmationOptions] =
    useState<ContextUnsavedConfirmationOptionsType>(defaultUnsavedConfirmationOption);

  return (
    <UnsavedConfirmationContext.Provider
      value={{
        isUnsavedConfirmationActive,
        setIsUnsavedConfirmationActive,
        contextUnsavedConfirmationOptions,
        setContextUnsavedConfirmationOptions,
      }}
    >
      {children}
    </UnsavedConfirmationContext.Provider>
  );
}

function useUnsavedConfirmationContext() {
  const context = useContext(UnsavedConfirmationContext);

  if (context === undefined) {
    throw new Error('Incorrect use of Context UnsavedConfirmationContext');
  }

  return context;
}

export { UnsavedConfirmationProvider, useUnsavedConfirmationContext, UnsavedConfirmationContext };
